import { styled } from '@mui/material/styles';
import { Link, LinkProps } from 'react-router-dom';
import { useLanguage } from '../../hooks/useLanguage';

const CustomSmallLink = styled(Link)(({ theme }) => ({
  color: theme.palette.text.secondary,
  textAlign: 'center',
  textDecoration: 'none',
  fontSize: '0.9em',
  '&:hover': {
    color: theme.palette.text.primary,
  },
}));

const SmallLink: React.FC<LinkProps> = (props) => {
  const { getPathWithLang } = useLanguage();
  const to =
    typeof props.to === 'string'
      ? getPathWithLang(props.to)
      : props.to?.pathname
        ? { ...props.to, pathname: getPathWithLang(props.to.pathname) }
        : props.to;

  return <CustomSmallLink {...props} to={to as any} />;
};

export default SmallLink;

